import React, { useState } from 'react'
import { Link } from 'react-router-dom'

interface FaqItem {
    id: number;
    question: string;
    answer: string;
}

export default function FaqV2() {
    const [activeIndex, setActiveIndex] = useState<number>(1);

    const faqData: FaqItem[] = [
        {
            id: 1,
            question: 'Nasıl çalışır?',
            answer: 'Uygulamamız, Kur\'an-ı Kerim ve Risale-i Nur hatimlerinizi bireysel veya grup halinde kolayca takip etmenizi sağlayan basit ve kullanıcı dostu bir arayüze sahiptir.'
        },
        {
            id: 2,
            question: 'Grup oluşturmak için ne yapmam gerekiyor?',
            answer: 'Uygulamaya giriş yaptıktan sonra "Grup Oluştur" butonuna tıklayarak kendi hatim grubunuzu kolayca kurabilir ve arkadaşlarınızı davet edebilirsiniz.'
        },
        {
            id: 3,
            question: 'Hatim takibi nasıl yapılır?',
            answer: 'Oluşturduğunuz veya katıldığınız hatim grubunda, size atanan cüzleri işaretleyerek ilerlemenizi kaydedebilir ve diğer katılımcıların da ilerlemesini görebilirsiniz.'
        },
        {
            id: 4,
            question: 'Uygulama ücretsiz mi?',
            answer: 'Evet, HatimTakip tamamen ücretsiz bir uygulamadır. Tüm özellikler herkes için açık ve hiçbir ücret talep edilmemektedir.'
        },
        {
            id: 5,
            question: 'Hangi platformlarda kullanılabilir?',
            answer: 'HatimTakip Android ve iOS cihazlar için mevcuttur.'
        }
    ];

    const toggleAccordion = (index: number) => {
        setActiveIndex(activeIndex === index ? -1 : index);
    };

    return (
        <section className="ht-sec" id="faqs">
            <div className="ht-wrap ht-faq">
                <div className="ht-faq-text">
                    <p className="ht-eyebrow">Sık Sorulan Sorular</p>
                    <h2 className="ht-h2">Merak Edilenler</h2>
                    <p className="ht-lead-p">
                        Uygulamamız hakkında en çok sorulan soruların cevaplarını burada bulabilirsiniz.
                        Başka sorularınız için <Link to="/support">destek</Link> ekibimizle iletişime geçebilirsiniz.
                    </p>
                </div>
                <div className="ht-acc">
                    {faqData.map((item) => {
                        const acik = activeIndex === item.id;
                        return (
                            <div key={item.id} className={`ht-acc-item ${acik ? 'is-open' : ''}`}>
                                <h3>
                                    <button
                                        type="button"
                                        className="ht-acc-btn"
                                        aria-expanded={acik}
                                        aria-controls={`sss-${item.id}`}
                                        onClick={() => toggleAccordion(item.id)}
                                    >
                                        {item.question}
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
                                    </button>
                                </h3>
                                {acik && (
                                    <div className="ht-acc-body" id={`sss-${item.id}`}>
                                        <p>{item.answer}</p>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
